






















import { Component, Vue } from 'vue-property-decorator';

import { Order } from '@/models/Order';
import { OrderType } from '@/constants/OrderType';
import { ContractService } from '@/services/ContractService';
import { StateManager } from '@/services/StateManager';
import { BigNumber } from 'ethers/utils';
import * as Helper from '@/helpers/Utils';
import { utils } from 'ethers';

@Component<Orderbook>({
  mounted() {
    Helper.Utils.scrollToBottom('sellorders');
  },
  updated() {
    Helper.Utils.scrollToBottom('sellorders');
  },
})
@Component
export default class Orderbook extends Vue {
  private state = StateManager.GetInstance().GetState();

  get buyOrders(): Order[] {
     const orderbook = ContractService.GetOrderbook(this.state);
     return orderbook.buyOrders;
  }

  get sellOrders(): Order[] {
    const orderbook = ContractService.GetOrderbook(this.state);
    return orderbook.sellOrders;
  }

  public rateUnit(rate: BigNumber) {
    const rateForDisplay = Helper.Utils.PriceIncludingDecimals(rate);
    return Helper.Utils.ComputeOptimalPriceUnit(rateForDisplay);
  }

  public displayQuantity(quantity: BigNumber) {
    return Helper.Utils.FormatFCCountForDisplay(quantity);
  }

  public displayRate(rate: BigNumber) {
    const rateForDisplay = Helper.Utils.PriceIncludingDecimals(rate);
    return utils.formatUnits(rateForDisplay, this.rateUnit(rate));
  }

  public displayAddress(address: string) {
    return Helper.Utils.FormatAddressForDisplay(address);
  }

  public showInConsole(prefix: string, object: any) {
    Helper.Utils.LogText('Info: ' + prefix + object.toString());
  }
}
